'use client'

import { useMemo, type ReactNode } from 'react'
import { useTranslations } from 'next-intl'
import { getQualityCopy } from '@/lib/i18n/quality-copy'
import { QualityCopyContext } from './quality-copy-context'

export function QualityCopyProvider({ children }: { children: ReactNode }) {
  const metrics = useTranslations('QualityMetrics')
  const outcomes = useTranslations('QualityOutcomes')
  const ui = useTranslations('QualityUi')
  const copy = useMemo(() => getQualityCopy(metrics, outcomes, ui), [metrics, outcomes, ui])
  return <QualityCopyContext.Provider value={copy}>{children}</QualityCopyContext.Provider>
}
